import React, {Component} from "react";
import {ApiPostRaw} from "../../../shared/services/api-service";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import {minutesToFormatted} from "../reports/dynamic-form/TimeTrackingField";
import './TimeAnalytics.scss'
import TimeChart from "./TimeChart";

const phaseOrder = ['completed', 'opened', 'pending'];

class TimeAnalytics extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timeTrack: []
    }
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.oitGuids.length !== this.props.oitGuids.length) {
      this.load()
    }
  }

  get oitsInProgress() {
    return this.props.oits
  }

  load() {
    ApiPostRaw('/api/v1/analytics/time-track', {
      users: this.props.oitGuids
    }).then(res => {
      this.setState({
        timeTrack: res
      })
    })
  }

  getOit(oitGuid) {
    if(this.props.userContext.hasScope('oit')) {
      return this.props.myTrainingProgram.oit
    }
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  get selectedOits() {
    return this.props.oitGuids.map(oitGuid => this.getOit(oitGuid))
  }

  getTotalSegment(segments) {
    return segments.find(s => s.segment === 'total') || {total: 0, average: 0}
  }

  getTotal(tt) {
    return tt.phases.reduce((acc, p) => {
      let segment = this.getTotalSegment(p.segments);
      if(!segment) {
        return acc;
      }
      return acc + segment.total
    }, 0)
  }

  getPhase(sequence, oitGuid) {
    return this.getOit(oitGuid)
        .trainingPhases
        .find(tp => tp.sequence === sequence)
  }

  getPhaseHours(phases, oitPhase) {
    return phases.find(pt => pt.phase_sequence === oitPhase.sequence) || {segments: []}
  }

  orderedPhases(trainingPhases) {
    return trainingPhases.sort(function compare(a, b) {
      return phaseOrder.indexOf(a.status) - phaseOrder.indexOf(b.status)
    })
        .filter(tp => tp.hours)
  }

  render() {
    let enableTimeChart = this.props.enableTimeChart !== false
    return (
      <div className="time-analytics">
        {enableTimeChart &&
          this.state.timeTrack.map(tt => (
            <div key={tt.user_guid}>
              <div className="user-name">{this.getOit(tt.user_guid) ? this.getOit(tt.user_guid).getFullName(): 'No name'}</div>
              {this.orderedPhases(this.getOit(tt.user_guid).trainingPhases).map(p => (
                  <TimeChart
                    key={p.sequence}
                    hours={this.getTotalSegment(this.getPhaseHours(tt.phases, p).segments).total}
                    phase={p}
                  />
              ))}
            </div>
          ))
        }
        { this.state.timeTrack.map(tt => (
          <div key={tt.user_guid}>
            <div className="user-name">{this.getOit(tt.user_guid) ? this.getOit(tt.user_guid).getFullName(): 'No name'}</div>
            <div className="time-tracking-table" style={{paddingTop: '10px'}}>
              <div>
                <div className="time-tracking-header" style={{color: '#fff', borderColor: '#fff'}}>#</div>
                <div className="time-tracking-time">Training time</div>
                <div className="time-tracking-time">Average by day</div>
              </div>
              {tt.phases.map(p => (
                <div key={p.phase}>
                  <div className="time-tracking-header">{p.phase}</div>
                  <div  className="time-tracking-time">{minutesToFormatted(this.getTotalSegment(p.segments).total)}</div>
                  <div  className="time-tracking-time">{minutesToFormatted(this.getTotalSegment(p.segments).average)}</div>
                </div>
              ))}
              <div>
                <div className="time-tracking-header">All phases</div>
                <div  className="time-tracking-time">{minutesToFormatted(this.getTotal(tt))}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext,
    myTrainingProgram: state.myTrainingProgram,
  };
}

export default connect(mapStateToProps)(TimeAnalytics)
